import { QueryClient, dehydrate } from '@tanstack/react-query'
import { BadRequest } from '@tsed/exceptions'
import { QueryKeys } from 'lib/react-query'
import queryAnimalArchivePage from 'query/animal-archive'
import queryAnimalLotties from 'query/common/lotties'
import queryProducts from 'query/common/products'
import { animalArchivePageConfig } from '../animal-archive.config'
import { AnimalArchivePage } from '../pages'
import type TAnimalArchivePage from '../types'

export default function AnimalArchiveRoute(props: TAnimalArchivePage) {
  return <AnimalArchivePage {...props} />
}

export const getAnimalArchiveStaticProps = async (animalType: string, locale?: string) => {
  if (locale === undefined) {
    throw new BadRequest('locale is missing')
  }

  const { i18nNamespaces } = animalArchivePageConfig

  const queryClient = new QueryClient()
  const products = await queryClient.fetchQuery([QueryKeys.GetAnimalProductsListing], () =>
    queryProducts(locale, animalType),
  )
  const page = await queryClient.fetchQuery([QueryKeys.GetAnimalArchivePage, animalType], () =>
    queryAnimalArchivePage(animalType, locale),
  )

  const lotties = await queryClient.fetchQuery([QueryKeys.GetAnimalLotties], () => queryAnimalLotties(true, locale))

  const hasProducts = products.productTypes.some((type) => {
    const productLength = type.products?.length ?? 0
    return productLength > 0
  })

  if (!hasProducts && !page && !lotties) {
    return {
      notFound: true,
      i18nNamespaces,
      locale,
    }
  }

  const seo = {
    seo: page?.pages?.[0]?.translations?.[0]?.seo,
    pageTitle: page?.animals?.[0]?.translations?.[0]?.friendly_title?.toUpperCase(),
  }

  return {
    i18nNamespaces,
    locale,
    props: {
      dehydratedState: dehydrate(queryClient),
      animalType,
      seo,
    },
  }
}
